import axios from "../../../axios";
import simpleAxios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
const { parse } = require("rss-to-json");

/**
 * Coin Image
 * @param {coin symbol} payload
 */
export const iconImage = (payload) => {
  let name = payload.toLowerCase();

  return `${process.env.REACT_APP_ICON_URL}/32/color/${name}.png`;
};

/**
 * Get Configs
 */
export const getConfigs = createAsyncThunk("getConfigs", async () => {
  try {
    const { data } = await axios.get("/config");

    //
    let config = data.result;

    //
    return config;
  } catch (error) {
    return false;
  }
});

/**
 * Get Coins
 */
export const getCoins = createAsyncThunk("getCoins", async () => {
  try {
    const { data } = await axios.get("/coins");

    //
    let coins = data.result;

    //
    return coins;
  } catch (error) {
    return false;
  }
});

/**
 * Get All Market Coins
 */
export const getAllCoins = async (payload) => {
  try {
    const { data } = await axios.get("/coins/all", {
      params: {
        filter: payload,
      },
    });

    //
    let coins = data;
    let all = [];
    for (const [key, value] of Object.entries(coins)) {
      all.push(value);
    }

    //
    return all;
  } catch (error) {
    return false;
  }
};

/**
 * Get Latest alerts
 */
export const getLatestAlerts = async () => {
  try {
    const { data } = await axios.get("/signals/latest");

    //
    let alerts = data.result;
    let array = [];

    for (const [key, value] of Object.entries(alerts)) {
      array.push(value);
    }

    //
    return array;
  } catch (error) {
    return false;
  }
};

/**
 * Get Reports
 * @param {Date From} payload
 */
export const getReports = async (payload) => {
  try {
    const { data } = await axios.get("signals/report", {
      params: {
        dateFrom: payload,
      },
    });

    //
    let reports = data.result;

    //
    return reports;
  } catch (error) {
    return false;
  }
};

/**
 * Get Tops
 * @param {type , limit} payload
 */
export const getTops = async (payload) => {
  try {
    const { data } = await axios.get(`signals/${payload.type}`, {
      params: {
        limit: payload.limit,
      },
    });

    //
    let items = data.result;
    let time = data.timestamp;

    //
    return { items, time };
  } catch (error) {
    return false;
  }
};

/**
 * Get Top Winners
 * @param {Date From, action, limit} payload
 */
export const getTopWinners = async (payload) => {
  try {
    const { data } = await axios.get(`signals/top-winners`, {
      params: {
        dateFrom: payload.dateFrom,
        action: payload.action,
        limit: payload.limit,
      },
    });

    //
    let items = data.result;

    //
    return items;
  } catch (error) {
    return false;
  }
};

/**
 * Get Alerts
 */
export const getAlertHistory = async (payload) => {
  try {
    const { data } = await axios.get("/signals/history", {
      params: payload,
    });

    //
    let signals = data.data;
    let lastPage = data.meta.last_page;
    let currentPage = data.meta.current_page;
    let total = data.meta.total;

    //
    return { signals, lastPage, currentPage, total };
  } catch (error) {
    return false;
  }
};

/**
 * Get Alerts Excel File
 */
export const getAlertHistoryExcel = async (payload) => {
  try {
    const { data } = await axios.get("/signals/history/excel-export", {
      params: payload,
      responseType: "blob",
    });

    //
    const blob = new Blob([data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = window.URL.createObjectURL(blob);
    window.open(url);

    //
    return true;
  } catch (error) {
    return false;
  }
};

/**
 * Get Available Coins
 */
export const getAvailableCoins = async (payload) => {
  try {
    const { data } = await axios.get("/coins/available", {
      params: payload,
    });

    //
    let available = data.data;
    let lastPage = data.meta.last_page;
    let currentPage = data.meta.current_page;
    let total = data.meta.total;

    //
    return { available, lastPage, currentPage, total };
  } catch (error) {
    return false;
  }
};

/**
 * Get Most Changed Volume
 */
export const getMostChangedVolume = async () => {
  try {
    const { data } = await axios.get("/coins/most-change-volume-chart");

    //
    let list = data.result;

    //
    return list;
  } catch (error) {
    return false;
  }
};

/**
 * Get Fear & Greed History
 * @param {days} payload
 */
export const getFearGreedHistort = async (payload) => {
  try {
    const { data } = await axios.get("/coins/fear-and-greed-index/history", {
      params: {
        days: payload,
      },
    });

    //
    let series = data.data.datasets[0].data;
    let labels = data.data.labels;

    //
    return { series, labels };
  } catch (error) {
    return false;
  }
};

/**
 * Get Fear & Greed (Limit 4)
 */
export const getFearGreed = async (payload) => {
  try {
    const { data } = await simpleAxios.get("https://api.alternative.me/fng/", {
      params: {
        limit: 4,
      },
    });

    //
    let fear_greed = data.data;

    //
    return fear_greed;
  } catch (error) {
    return false;
  }
};

// export const getTrendingTicker = async() => {
//     try {
//         const { data } = await simpleAxios.get(
//             "https://api.alternative.me/v2/ticker/?limit=5"
//         );

// console.log(data);
//     } catch (error) {}
// };

/**
 * Get Coin Info
 * @param {symbol, dateFrom, dateTo} payload
 */
export const getCoinInfo = async (payload) => {
  try {
    const { data } = await axios.get(`/coins/${payload.symbol}`, {
      params: {
        dateFrom: payload.dateFrom,
        dateTo: payload.dateTo,
      },
    });

    //
    const { marketData, chart } = data.result;

    //
    return { marketData, chart };
  } catch (error) {
    return false;
  }
};

/**
 * Get Report Alert History
 * @param {symbol , dateFrom, dateTo, page} payload
 */
export const getReportAlertHistory = async (payload) => {
  try {
    const { data } = await axios.get(`coins/${payload.symbol}/signals`, {
      params: payload.param,
    });

    //
    let signals = data.data;
    let lastPage = data.meta.last_page;
    let currentPage = data.meta.current_page;
    let total = data.meta.total;

    //
    return { signals, lastPage, currentPage, total };
  } catch (error) {
    return false;
  }
};

/**
 * Get Report Alert History
 * @param {symbol , start_date, end_date, page} payload
 */
export const getReportAlertHistoryExcel = async (payload) => {
  try {
    const { data } = await axios.get(
      `coins/${payload.symbol}/signals/excel-export`,
      {
        params: payload.param,
        responseType: "blob",
      }
    );

    //
    const blob = new Blob([data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = window.URL.createObjectURL(blob);
    window.open(url);

    //
    return true;
  } catch (error) {
    return false;
  }
};

/**
 * Get Price
 * @param {symbol , date} payload
 */
export const getPrice = async (payload) => {
  try {
    const { data } = await axios.get("/coins/price", {
      params: {
        baseCoin: payload.baseCoin,
        symbol: payload.symbol,
        date: payload.date,
      },
    });

    //
    let price = data.result;

    //
    return price;
  } catch (error) {
    return false;
  }
};

/**
 * Get Coin Evenets
 * @param {coin: coin id} payload
 */
export const getEvents = async (payload) => {
  try {
    const { data } = await axios.get("/events", {
      params: {
        "categoryIds[]": payload,
      },
    });

    //
    let events = data.result;

    //
    return events;
  } catch (error) {
    return false;
  }
};

/**
 * Get Categories for news and events
 */
export const getCategories = async () => {
  try {
    const { data } = await axios.get("/news/categories");

    //
    const { types, list } = data.result;
    let category = {};

    // set object for all types
    for (let i = 0; i < types.length; i++) {
      const type = types[i];
      category[type] = [];
    }

    // set data for every type
    for (const [key, value] of Object.entries(category)) {
      for (let i = 0; i < list.length; i++) {
        const element = list[i];
        if (element.type === key) {
          value.push({
            name: element.name,
            value: element.key,
          });
        }
      }
    }

    return category;
  } catch (error) {
    return false;
  }
};

/**
 * Get News
 */
export const getNews = async (payload) => {
  try {
    const origin = window.location.origin;
    const baseURL = process.env.REACT_APP_BASE_URL_API.includes("http")
      ? process.env.REACT_APP_BASE_URL_API
      : `${origin}/${process.env.REACT_APP_BASE_URL_API}`;

    const rss = await parse(`${baseURL}/news?category=${payload}`);

    //
    let news = rss.items;

    for (let i = 0; i < news.length; i++) {
      const element = news[i];

      // splite image
      // let image = element.content.split('src="')[1].split('" class')[0];

      // remove last 3 zero from published
      // let published = element.published.toString().slice(0, -3);
      // element.published = published;

      // set title as slug
      let title = element.title.replace(/\s/g, "-").replace("%", "");
      element.slug = title;
    }

    //
    return news;
  } catch (error) {
    return false;
  }
};

/**
 * Get Coin Additional Information
 * @param {coin symbol} payload
 */
export const getCoinAdditionalInfo = async (payload) => {
  try {
    const { data } = await axios.get(`/coins/${payload}/details`);

    //
    let info = data.result;

    //
    return info;
  } catch (error) {
    return false;
  }
};

/**
 * Get Fear & Greed (Limit 4)
 */
export const getCoindestBTCHistory = async (payload) => {
  try {
    const { data } = await simpleAxios.get(
      `https://api.coindesk.com/v1/bpi/historical/close.json?start=${payload.start}&end=${payload.end}`
    );

    //
    return data;
  } catch (error) {
    return false;
  }
};

/**
 * Charge Points
 * @param {amount} payload
 */
export const chargePoint = async (payload) => {
  try {
    const { data } = await axios.post("payments/stripe/chargePoint", payload);

    return data.result;
  } catch (error) {
    return false;
  }
};
